<div class="flex justify-between gap-4">
  <h1 class="orgbrain-bold-sub-header !mt-0 p-0 mb-2">
    {{ title }}
  </h1>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="orgbrain-style">
  <div class="d-flex justify-between flex-col">
    <p class="orgbrain-gray-text" *ngIf="!isQuestionAnArray(); else questionArrayTemplate">
      <span [innerHTML]="question"></span>
    </p>
    <mat-dialog-actions align="end" class="mb-pixel-0 pb-pixel-0">
      <button
        mat-button
        class="action-button"
        color="primary"
        id="confirm_dialog_no_button"
        *ngIf="noOptionTitle"
        (click)="dialogRef.close(reverseLogic)"
        cdkFocusInitial
      >
        {{ noOptionTitle }}
      </button>

      <button
        mat-button
        color="primary"
        class="action-button"
        style="margin-right: 10px"
        id="confirm_dialog_yes_button1"
        *ngIf="alternativeOptionTitle"
        (click)="dialogRef.close(1)"
      >
        {{ alternativeOptionTitle }}
      </button>
      <button
        mat-flat-button
        color="primary"
        class="action-button"
        id="confirm_dialog_yes_button"
        *ngIf="yesOptionTitle"
        (click)="dialogRef.close(!reverseLogic)"
      >
        {{ yesOptionTitle }}
      </button>
    </mat-dialog-actions>
  </div>
  <ng-template #questionArrayTemplate>
    <p class="orgbrain-gray-text" *ngFor="let q of question" [innerHTML]="q"></p>
  </ng-template>
</div>
